import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ModelStatus } from 'src/app/core/model/tenants/model-status.model';
import { TenantClientService } from 'src/app/core/services/tenant-client.service';
import { TranslateService } from 'src/app/core/services/translate.service';

@Component({
  selector: 'app-model-status',
  templateUrl: './model-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModelStatusComponent implements OnInit {
  tenantCode: string;
  status: ModelStatus | null = null;
  loading = true;
  error = false;
  downloading = false;
  downloadFailed = false;

  constructor(
    private api: TenantClientService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.tenantCode = this.route.snapshot.params['tenantCode'];
    this.api
      .getModelStatus(this.tenantCode)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (status) => {
          this.status = status;
          this.loading = false;
        },
        error: () => {
          this.error = true;
          this.loading = false;
        },
      });
  }

  get upgradeBody(): string {
    return this.translate.get('model.upgrade_body').replace('{count}', String(this.status?.upgradableFiles ?? 0));
  }

  onDownloadUpgrade(): void {
    this.downloading = true;
    this.downloadFailed = false;
    this.api
      .downloadModelUpgrade(this.tenantCode)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ blob, filename }) => {
          this.downloading = false;
          saveBlob(blob, filename);
          this.cdr.markForCheck();
        },
        error: () => {
          this.downloading = false;
          this.downloadFailed = true;
          this.cdr.markForCheck();
        },
      });
  }
}

function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
